import { Icon } from "@/components/atoms";
import { Tabs } from "@/components/molecules";
import { useOperator } from "@/hooks";
import { useGetVehicleTypesQuery } from "@/redux/apis/config/trip/vehicleType/vehicleTypeApi";
import { useGetVehicleTypesParams } from "@/components/organisms/VehicleTypes/VehicleTypes/hooks/useGetVehicleTypesParams";

export const TransferVehicleOptionsTabs = () => {
  const { id: operatorId } = useOperator();
  const { params } = useGetVehicleTypesParams();
  const { data } = useGetVehicleTypesQuery(params);

  const pageTabs = [
    {
      name: "Vehicle Type",
      to: `/operator/${operatorId}/config/trip/vehicle-types`,
    },
    {
      name: "Transfer Types",
      to: `/operator/${operatorId}/config/trip/transfer-types`,
      isLocked: data ? data.page.total < 1 : false,
    },
    {
      name: "Extras",
      to: `/operator/${operatorId}/config/trip/fixed-cost-extras`,
    },
    {
      name: "Vehicle Manager",
      to: `/operator/${operatorId}/vehicles`,
      icon: <Icon name="ExportSquare" size="md" className="ml-2" />,
    },
  ];

  return <Tabs className="no-scrollbar min-w-0" tabs={pageTabs} />;
};
